import {EVENT_SHOPPING_CART, LOCALE_STORAGE_SHOPPING_CART} from './constants'
import showProductAddedPopup from './util/showProductAddedPopUp';
import addToCart from './util/addToCart';

/**
 * shoppingCartItem stored inside localStorage
 * @typedef ShoppingCartItem
 * @property {string} productUri
 * @property {string} productName
 * @property {string} productClass
 * @property {string} productNumber
 * @property {string} packageSize
 * @property {number} quantity
 */

/**
 * @return {void}
 */
function InitShoppingCartIcon() {

    /**
     * @return {number}
     */
    function getShoppingCartItemNumber() {
        const items = localStorage.getItem(LOCALE_STORAGE_SHOPPING_CART)

        if (!items) {
            return 0
        } else {
            return JSON.parse(items).length
        }
    }

    /**
     * @param {Element} shoppingCart
     * @param {number} numberOfElements
     * @return {void}
     */
    function setItems(shoppingCart, numberOfElements) {
        shoppingCart.setAttribute('data-shopping-cart-items', numberOfElements.toString())
    }

    /**
     * @return {void}
     */
    function updateShoppingCart() {
        document.querySelectorAll('[data-shopping-cart]').forEach(function (shoppingCart) {
            const numberOfItems = getShoppingCartItemNumber()
            setItems(shoppingCart, numberOfItems)
        });
    }

    updateShoppingCart()
    window.addEventListener(EVENT_SHOPPING_CART, updateShoppingCart)
}

/**
 * @return {void}
 */
function InitAddToCartButton() {
    document.querySelectorAll('[data-order-row]').forEach(function (orderRow) {
        const productClassElement = orderRow.querySelector('[data-product-class]')
        const packageSizeElement = orderRow.querySelector('[data-package-size]')
        const numberInputElement = orderRow.querySelector('[data-number-input]')
        const addToCartButton = orderRow.querySelector('[data-add-to-cart-button]')
        const productNumberElement = orderRow.querySelector('[data-product-number]')
        const productUriElement = orderRow.querySelector('[data-product-uri]')
        const productName = document.querySelector('[data-product-name]')

        if (!addToCartButton) return

        /**
         * @param {MouseEvent} event
         */
        addToCartButton.onclick = (event) => {
            const quantityValue = numberInputElement.querySelector('[data-number-input__display]').value
            if (quantityValue > 0) {
                const productClassValue = productClassElement.textContent;
                const packageSizeValue = packageSizeElement ? (packageSizeElement.textContent ? packageSizeElement.textContent : packageSizeElement.querySelector('input').value) : '-';
                const productNumberValue = productNumberElement.textContent;
                const productUriValue = productUriElement.textContent;
                const productNameValue = productName.innerHTML;

                addToCart(productUriValue, productNameValue, productClassValue, productNumberValue, packageSizeValue, quantityValue);
                showProductAddedPopup(event.clientX, event.clientY);
            }
        }
    })
}

/**
 * @return {void}
 */
function InitShoppingCartTable() {
    /**
     * @return {any|boolean}
     */
    function getShoppingCartItems() {
        const items = localStorage.getItem(LOCALE_STORAGE_SHOPPING_CART)

        if (!items || JSON.parse(items).length < 1) {
            document.querySelector('.shopping-cart--empty').classList.remove('hidden');
            return false;
        } else {
            document.querySelector('.shopping-cart--filled').classList.remove('hidden');
            return JSON.parse(items)
        }
    }

    /**
     * @return {undefined|HTMLTableSectionElement}
     */
    function constructTableBody() {
        const shoppingCartItems = getShoppingCartItems()

        if (!shoppingCartItems) return

        const tableBody = document.createElement('tbody')

        shoppingCartItems.forEach((shoppingCartItem, index) => {
            const tableRow = constructTableRow(shoppingCartItem, index)
            tableBody.appendChild(tableRow)
        })

        return tableBody
    }

    /**
     *
     * @param {ShoppingCartItem} shoppingCartItem
     * @param {number} index
     * @return {HTMLTableRowElement}
     */
    function constructTableRow(shoppingCartItem, index) {
        const tr = document.createElement('tr')
        const productRowId = shoppingCartItem.productNumber + '-' + index
        tr.dataset.productRowId = productRowId;

        const productNameCell = document.createElement('td')
        productNameCell.classList.add('td--block');
        const productName = document.createElement('div');
        productName.innerHTML = shoppingCartItem.productUri ? '<a href="' + shoppingCartItem.productUri + '">' + shoppingCartItem.productName + '</a>' : shoppingCartItem.productName;
        const productClass = document.createElement('input')
        productClass.setAttribute('readonly', 'readonly');
        productClass.setAttribute('name', 'product['+ index + '][productName]');
        productClass.setAttribute('value', shoppingCartItem.productClass)
        productNameCell.appendChild(productName);
        productNameCell.appendChild(productClass);

        const productNumberCell = document.createElement('td')
        const productNumberLabel = document.createElement('span')
        productNumberLabel.classList.add('mobile-only', 'cart__label');
        productNumberLabel.innerHTML = document.querySelector('[data-label-for="productNumber"]').innerHTML + ':';
        const productNumber = document.createElement('input')
        productNumber.setAttribute('readonly', 'readonly');
        productNumber.setAttribute('name', 'product['+ index + '][productNumber]');
        productNumber.setAttribute('value', shoppingCartItem.productNumber)
        productNumberCell.appendChild(productNumberLabel);
        productNumberCell.appendChild(productNumber);
        const fillingAmountLabel = document.createElement('span')
        fillingAmountLabel.classList.add('mobile-only', 'cart__label');
        fillingAmountLabel.innerHTML = document.querySelector('[data-label-for="fillingAmount"]').innerHTML + ':';
        const fillingAmountCell = document.createElement('td')
        const fillingAmount = document.createElement('input')

        fillingAmount.setAttribute('readonly', 'readonly');
        fillingAmount.setAttribute('name', 'product['+ index + '][fillingAmount]');
        fillingAmount.setAttribute('value', shoppingCartItem.packageSize || '');
        fillingAmountCell.appendChild(fillingAmountLabel);
        fillingAmountCell.appendChild(fillingAmount);

        const quantity = createNumberInputElement(shoppingCartItem, index)

        const trashBinIcon = createTrashBin(productRowId)
        trashBinIcon.onclick = function () {
            updateLocalStorage(shoppingCartItem, null);
        }

        tr.appendChild(productNameCell)
        tr.appendChild(productNumberCell)
        tr.appendChild(fillingAmountCell)
        tr.appendChild(quantity)
        tr.appendChild(trashBinIcon)

        return tr
    }

    /**
     * @param {ShoppingCartItem} shoppingCartItem
     * @param {HTMLInputElement|null} input
     */
    function updateLocalStorage(shoppingCartItem, input = null) {
        const items = JSON.parse(localStorage.getItem(LOCALE_STORAGE_SHOPPING_CART));
        const currentItemInLocalStorage = items.find(item => item.productNumber === shoppingCartItem.productNumber && item.packageSize === shoppingCartItem.packageSize);
        const currentItemPosition = items.indexOf(currentItemInLocalStorage);

        if(currentItemPosition >= 0) {
            if (!!input) {
                // update item quantity
                items[currentItemPosition].quantity = input.value;
                localStorage.setItem(LOCALE_STORAGE_SHOPPING_CART, JSON.stringify(items));
            } else {
                // remove item by checking product number and packageSize
                const updatedItems = items.filter(item => item.productNumber !== shoppingCartItem.productNumber || item.packageSize !== shoppingCartItem.packageSize);
                if(updatedItems.length < 1) {
                    localStorage.removeItem(LOCALE_STORAGE_SHOPPING_CART);
                    document.querySelector('.shopping-cart--filled').classList.add('hidden');
                    document.querySelector('.shopping-cart--empty').classList.remove('hidden');
                } else {
                    localStorage.setItem(LOCALE_STORAGE_SHOPPING_CART, JSON.stringify(updatedItems));
                }

            }
        }
    }

    /**
     * @param {ShoppingCartItem} shoppingCartItem
     * @param {number} index
     * @return {HTMLTableCellElement}
     */
    function createNumberInputElement(shoppingCartItem, index) {
        const td = document.createElement('td')
        td.classList.add('td--inline');

        const container = document.createElement('div')
        container.classList.add('number-input')
        container.dataset.numberInput = ''

        const display = document.createElement('input')
        display.setAttribute('type', 'number')
        display.classList.add('number-input__item', 'number-input__value')
        display.setAttribute('value', shoppingCartItem.quantity.toString())
        display.setAttribute('name', 'product['+ index + '][productQuantity]');
        display.setAttribute('min', '0')
        display.dataset.numberInput__display = ''

        const subButton = document.createElement('button')
        subButton.classList.add('number-input__item', 'icon-minus')
        subButton.setAttribute('type', 'button')
        subButton.onclick = function () {
            display.stepDown(1);
            updateLocalStorage(shoppingCartItem, display);
        }

        const addButton = document.createElement('button')
        addButton.classList.add('number-input__item', 'icon-plus')
        addButton.setAttribute('type', 'button')
        addButton.onclick = function() {
            display.stepUp(1);
            updateLocalStorage(shoppingCartItem, display);
        }

        container.appendChild(subButton)
        container.appendChild(display)
        container.appendChild(addButton)

        td.appendChild(container)

        return td
    }

    /**
     * @param {string} productNumber
     * @return {HTMLTableCellElement}
     */
    function createTrashBin(productNumber) {
        const td = document.createElement('td')
        td.classList.add('td--inline');

        const icon = document.createElement('i')
        icon.classList.add('icon', 'icon-bin', 'icon--large', 'icon--hover')

        td.appendChild(icon)

        icon.onclick = () => {
            document.querySelectorAll('[data-product-row-id]').forEach(function (productRow) {
                if (productRow.dataset.productRowId === productNumber) {
                    productRow.remove()
                }
            })
        }

        return td
    }

    document.querySelectorAll('[data-shopping-cart-table]').forEach(function (shoppingCartTable) {
        const tableBody = constructTableBody()
        if (!!tableBody) {
            shoppingCartTable.appendChild(tableBody);
        }
    })
}

/**
 * @return {void}
 */
export default function () {
    InitShoppingCartIcon()
    InitAddToCartButton()
    InitShoppingCartTable()
}
